"use client";

import React, { useEffect, useState } from "react";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const HERO_IMAGES = [{
  desktopSrc: "https://saraandmichael2026.com/wp-content/uploads/2026/04/IMG_1364-scaled.jpeg",
  mobileSrc: "https://saraandmichael2026.com/wp-content/uploads/2026/04/WhatsApp-Image-2026-04-11-at-5.40.30-PM.jpeg",
  alt: "Cinematic Roman sunset with a slow pan across the horizon",
  mobilePosition: "object-center",
  desktopPosition: "object-center"
}, {
  desktopSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1593781/img/roman_sunset_cinematic.png",
  mobileSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1593781/img/roman_sunset_cinematic.png",
  alt: "The Colosseum at dusk under a warm Italian sky",
  mobilePosition: "object-center",
  desktopPosition: "object-center"
}, {
  desktopSrc: "https://saraandmichael2026.com/wp-content/uploads/2026/04/a75bfb09-1e54-4f5f-872d-ceb6539e64c1-1.jpg",
  mobileSrc: "https://saraandmichael2026.com/wp-content/uploads/2026/04/IMG_2735.jpeg",
  alt: "The elegant architecture of Villa Aurelia in Rome",
  mobilePosition: "object-center",
  desktopPosition: "object-center"
}];
export default function WhereMemoriesBegin() {
  const [api, setApi] = useState<CarouselApi>();
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  useEffect(() => {
    if (!api) return;
    const interval = setInterval(() => {
      api.scrollNext();
    }, 6000);
    return () => clearInterval(interval);
  }, [api]);
  return <section data-section-id="25411" id="benvenuti-a-roma" className="relative w-full overflow-hidden bg-background">
      {/* This is the sizing anchor — everything inside must inherit from this */}
      <div className="relative w-full h-[75svh] md:mx-auto md:max-w-[1700px] md:h-[90svh] md:max-h-[950px]">

        {/*
          [&>div]:h-full forces the internal Embla wrapper div that
          shadcn/Carousel renders to also be full height — without this,
          it defaults to auto and the images collapse.
         */}
        <Carousel setApi={setApi} opts={{
        loop: true,
        duration: 60
      }} className="h-full w-full [&>div]:h-full">
          {/* -ml-0 removes the default negative margin; h-full cascades down */}
          <CarouselContent className="-ml-0 h-full">
            {HERO_IMAGES.map((image, index) => <CarouselItem key={index} data-index={index} className="pl-0 basis-full h-full">
                {/* position:relative + h-full so the overlay div can be absolute */}
                <div className="relative w-full h-full">
                  {/* Mobile image */}
                  <img src={image.mobileSrc} alt={image.alt} className={`md:hidden absolute inset-0 w-full h-full object-cover ${image.mobilePosition}`} />

                  {/* Desktop image */}
                  <img src={image.desktopSrc} alt={image.alt} className={`hidden md:block absolute inset-0 w-full h-full object-cover ${image.desktopPosition}`} />

                  {/* Dark overlay */}
                  <div className="absolute inset-0 bg-black/30 md:bg-black/20" />
                </div>
              </CarouselItem>)}
          </CarouselContent>
        </Carousel>

        {/* Text overlay — sits above carousel via z-10, centered both axes */}
        <div className="absolute inset-0 z-10 flex items-center justify-center px-5 text-center">
          <div ref={textRef} className={`mx-auto w-full max-w-4xl transition-all duration-1000 ease-out ${textVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
       <h1 className="font-serif italic text-[40px] leading-[1.05] tracking-tight drop-shadow-2xl sm:text-6xl md:text-[120px]" style={{
            color: "#e8d5a3",
            textShadow: "0 2px 20px rgba(0,0,0,0.6), 0 0 60px rgba(0,0,0,0.3)",
            WebkitTextStroke: "0.5px rgba(255,220,150,0.4)"
          }}>
  Benvenuti a Roma
</h1>

            <p className="mx-auto mt-4 max-w-[260px] font-sans text-[10px] uppercase tracking-[0.22em] text-white/90 drop-shadow-md sm:mt-6 sm:max-w-2xl sm:text-sm md:text-lg">
              September 11, 2026 · Rome
            </p>

            <div className="mt-7 sm:mt-10">
              <Button asChild size="lg" className="h-11 rounded-none bg-primary px-6 text-sm font-medium text-primary-foreground transition-all duration-300 hover:bg-primary/90 sm:h-14 sm:px-8 sm:text-lg">
                <Link to="/RSVPPage">RSVP</Link>
              </Button>
            </div>
          </div>
        </div>

      </div>
    </section>;
}